import { httpClient } from "../http/httpClient";
import { PartnerType } from "@/app/utils/partners.enum";

export interface MakeProposalPayload {
  nome: string;
  cpf: string;
  nascimento: string;
  telefone?: string;
  ocupacaoId: number;
  cep: string;
  pin?: string;
  sellerId?: string;
  city?: string;
  state?: string;
}

export interface MakeProposalResponse {
  propostaId: string;
}

export async function makeProposal(payload: MakeProposalPayload) {
  const { data } = await httpClient
    .post<MakeProposalResponse>("/crefaz", payload, {
      journey: PartnerType.CREFAZ,
    })
    .catch((error) => {
      throw error.response?.data ?? error;
    });

  return data;
}
